import axios from '@/plugins/axios'
import { Module } from 'vuex'
import router from '../router'

export interface Guest {
    username: string
    token: string
}

const guestModule: Module<any, any> = {
    state: {
        post: {},
    },

    actions: {
        async GetPost({ commit }) {
            const response = {
                post: {
                    profile: '/images/profile-img/img-06.jpg',
                    date: '2021-03-16',
                    name: 'John Doe',
                    message:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    link: '#',
                    image: '/images.login/blogimages/blogindexban.jpg',
                    text: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
                    footnote: 'wsj.com',
                    share: '#',
                    badges: [
                        {
                            id: 0,
                            type: 'success',
                            label: 'Featured',
                        },
                    ],
                    engagements: [
                        {
                            label: 'Likes',
                            link: '#',
                            count: 54,
                            icon: 'icon-thumb-up',
                        },
                        {
                            label: 'Comments',
                            link: '#',
                            count: 15,
                            icon: 'icon-comment-outline',
                        },
                        {
                            label: 'Shares',
                            link: '#',
                            count: 32,
                            icon: 'icon-share-all',
                        },
                    ],
                },
            }

            commit('setPost', response.post)

            return response
        },
    },

    mutations: {
        setPost(state: any, post) {
            state.post = post
        },
    },
}

export default guestModule
